import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getEquipmentProviderProps } from './providerProps';
import { InjectedPropsProvider } from '../../../Core/InjectedPropsContext';
import { actions } from '../../../../Data/ReduxViewModels/Equipment';

/**
 * The intention of this class is to apply common logic to all child components that should work consistently across
 * worksheets components that opt into consumption, e.g.:
 *    - Certain conditions should disable all components.
 *    - Save all input onChange values as they are entered, usng the Web API.
 */
let EquipmentInjectedPropsProvider = ({ children }) => {
  const dispatch = useDispatch();

  const equipmentId = useSelector((state) => state.equipment.equipmentId);

  const getProviderProps = useCallback(
    (consumerProps, modifiers) =>
      getEquipmentProviderProps(
        consumerProps,
        {
          equipmentId,
          setValue: (update) => dispatch(actions.setValue(update)),
          synchronise: () => dispatch(actions.synchronise()),
        },
        modifiers
      ),
    [equipmentId, dispatch]
  );

  return <InjectedPropsProvider getProviderProps={getProviderProps}>{children}</InjectedPropsProvider>;
};

export { EquipmentInjectedPropsProvider };
export default EquipmentInjectedPropsProvider;
